import { render, staticRenderFns } from "./ContentVersionForm.vue?vue&type=template&id=136f64bd&"
import script from "./ContentVersionForm.vue?vue&type=script&lang=ts&"
export * from "./ContentVersionForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports